<template>
	<div ref="wrapper">
		<div class="layout">
			<div class="layout-container">
				<div class="media">
					<slot name="media" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EVENT, bus } from '@videotools/js/events';
import toggleFullscreen from '@videotools/js/util/toggleFullscreen';

const events = [EVENT.FULLSCREEN_TOGGLE];

export default {
	name:     'Layout',
	computed: {
		...mapGetters({
			isMobileAppleDevice: 'device/isMobileAppleDevice',
		}),
	},
	mounted() {
		// subscribe to external events
		for (const event of events) {
			bus.subscribe(event, this[`BUS-${event}`]);
		}
	},
	destroyed() {
		// bus
		for (const event of events) {
			bus.unsubscribe(event, this[`BUS-${event}`]);
		}
	},
	methods: {
		[`BUS-${EVENT.FULLSCREEN_TOGGLE}`]() {
			if (this.isMobileAppleDevice) return; // handled by Player
			toggleFullscreen(this.$root.$el);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.wrapper {
	height: 100%;
}

.layout {
	background: var(--color-black);
	user-select: none;
	margin: 0 auto;
	overflow: hidden;
	height: 100%;

	.layout-container {
		height: 100%;
		display: flex;
		flex-direction: row;

		.media {
			flex: 1 1 0;
			display: flex;
			position: relative;
			overflow: hidden;
		}
	}
}
</style>
